import { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { Grid, Typography, Box } from "@mui/material";
import { Button } from "abs-ui-components";
import { callApi } from "../../../../../services/MonitoringPlanService";
import { API_ROUTES } from "../../ApiRoutes/ApiRoutes";
import { emitToasterMsg } from "../../../../../services/toasterUtility";
import RichTextEditor from "../../RichTextEditor/RichTextEditor";

const TotalTransportWork = ({ Totalwork, refetchMonitoringData, vesselMstId }) => {
	const editorRef = useRef(null);
	const [editorContent, setEditorContent] = useState("");
	const [lastSavedContent, setLastSavedContent] = useState(""); // ✅ Track saved state
	const [isSavingDescription, setIsSavingDescription] = useState(false);
	const [error, setError] = useState("");

	// Populate content from prop
	useEffect(() => {
		if (Totalwork) {
			setEditorContent(Totalwork);
			setLastSavedContent(Totalwork);
		}
	}, [Totalwork]);

	const handleSave = async () => {
		if (!editorRef.current) return;

		const editorHTML = editorRef.current.getHTML().trim();
		const cleaned = editorHTML
			.replace(/<p><br><\/p>/g, "")
			.replace(/&nbsp;/g, "")
			.trim();
		const hasContent = cleaned.length > 0 && cleaned !== "<p></p>" && cleaned !== "<br>" && cleaned !== "";
		if (!hasContent) {
			setError("Field is Required");
			return;
		}
		try {
			setIsSavingDescription(true);
			const res = await callApi({
				method: "POST",
				url: API_ROUTES.TotalTransportWork(vesselMstId),
				data: JSON.stringify(editorHTML),
				headers: {
					"Content-Type": "application/json",
				},
			});

			if (res?.isSuccess) {
				emitToasterMsg("success", "Total transport Work", "Saved successfully");
				await refetchMonitoringData?.();
				setError("");
				setEditorContent(editorHTML);
				setLastSavedContent(editorHTML);
			} else {
				emitToasterMsg("error", "Total transport Work", res?.errorMessage);
			}
		} catch (err) {
			emitToasterMsg("error", "Total transport Work", err.message);
		} finally {
			setIsSavingDescription(false);
		}
	};
	const isSaveDisabled = isSavingDescription || !editorContent.trim() || editorContent === lastSavedContent;

	return (
		<Box mt={3}>
			<Grid container spacing={2} alignItems="flex-start">
				<Grid item xs={12} md={2}>
					<Typography variant="body2" fontWeight={600} mb={1}>
						Description <span style={{ color: "red" }}>*</span>
					</Typography>
				</Grid>

				<Grid item xs={12} md={9}>
					<Box border="1px solid #ccc" borderRadius={1} p={1} sx={{ background: "#fff" }}>
						<RichTextEditor
							ref={editorRef}
							value={editorContent}
							onChange={setEditorContent}
							placeholder="Enter the description for total transport work..."
						/>
					</Box>

					{error && (
						<Typography variant="caption" color="error" mt={1}>
							{error}
						</Typography>
					)}

					<Box mt={2}>
						<Button onClick={handleSave} disabled={isSaveDisabled} size="small">
							Save
						</Button>
					</Box>
				</Grid>
			</Grid>
		</Box>
	);
};

export default TotalTransportWork;
